import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=5c8248cd"
import script from "./Bussiness.vue?vue&type=script&lang=js"
export * from "./Bussiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8248cd')) {
      api.createRecord('5c8248cd', component.options)
    } else {
      api.reload('5c8248cd', component.options)
    }
    module.hot.accept("./Bussiness.vue?vue&type=template&id=5c8248cd", function () {
      api.rerender('5c8248cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Bussiness.vue"
export default component.exports